export const tokens = {
  colors: {
    primary: '#4F46E5',
    primaryDark: '#4338CA',
    primaryLight: '#EEF2FF',
    success: '#10B981',
    successLight: '#ECFDF5',
    warning: '#F59E0B',
    warningLight: '#FFFBEB',
    error: '#EF4444',
    errorLight: '#FEF2F2',
    pageBg: '#F8FAFC',
    cardBg: '#FFFFFF',
    textPrimary: '#0F172A',
    textSecondary: '#475569',
    textTertiary: '#94A3B8',
    border: '#E2E8F0',
    borderStrong: '#CBD5E1',
  },
  typography: {
    displayLarge: 'text-3xl font-bold leading-tight',
    displayMedium: 'text-2xl font-bold leading-tight',
    headline: 'text-xl font-semibold leading-snug',
    title: 'text-lg font-semibold leading-snug',
    body: 'text-base font-normal leading-relaxed',
    bodyMedium: 'text-base font-medium leading-relaxed',
    label: 'text-sm font-medium leading-snug',
    caption: 'text-xs font-normal leading-snug',
  },
  spacing: {
    xs: '0.5', // 2dp
    sm: '1',   // 4dp
    md: '2',   // 8dp
    lg: '3',   // 12dp
    xl: '4',   // 16dp
    xxl: '6',  // 24dp
  },
  radius: {
    sm: 'rounded',
    md: 'rounded-lg',
    lg: 'rounded-xl',
    full: 'rounded-full',
  },
  elevation: {
    0: '',
    1: 'shadow-elevation-1',
    2: 'shadow-elevation-2',
    3: 'shadow-elevation-3',
    4: 'shadow-elevation-4',
  },
} as const;

export const variantLabels: Record<string, string> = {
  recommended: 'Recommended default',
  A: 'A — Header chip',
  B: 'B — Inline card',
  C: 'C — Sticky banner',
  D: 'D — Whitespace card',
  E: 'E — Pay Now adjacency',
  F: 'F — Post-payment card',
};

export const qualificationLabels: Record<QualificationState, string> = {
  unqualified: 'Unqualified',
  low: 'Low balance',
  negative: 'Negative balance',
  'predicted-low': 'Predicted low',
};

import type { QualificationState } from './types';
